<template>
  <div>
    <v-card-text class="pa-0" style="height: 500px; overflow-y: auto;">
      <v-layout class="pa-2" row wrap style="height: auto;" v-if="channel">
        <v-flex xs6 style="padding-bottom: 5px;" pr-1>
          <v-autocomplete
            :items="instances"
            v-model="instance"
            label="Instance"
            item-text="title"
            item-value="id"
            :hint="hint"
            :persistent-hint="true">
          </v-autocomplete>
        </v-flex>
        <v-flex xs6 style="padding-bottom: 5px;" pr-1>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
			<v-btn flat @click="reset">Reset</v-btn>
			<v-btn color="success" @click="save(false)">Save</v-btn>
			<v-btn color="success" @click="save(true)">Save and close</v-btn>
    </v-card-actions>
  </div>
</template>
<script>
import ChannelModel from '@/models/channel.js'
import InstanceModel from '@/models/instance.js'

export default {
  props: ['id'],
  data () {
    var ch = this.$cloudserver.channel("channels:"+this.id);
    return {
      ws_channel: ch,
      channel: this.convertChannel(ch.data),
      instance: undefined
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.channel = this.convertChannel(newVal, oldVal);
        }
      },
      deep: true
    },
    '$route' (to, from) {
      if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
        this.ws_channel = this.$cloudserver.channel("channels:"+this.id);
        this.ws_channel.join();
      }
    }
  },
  computed: {
    instances () {
      return _.filter(this.$store.state.instances, (instance) => { return instance.type == this.channel.type; });
    },
    hint() {
      var instance = InstanceModel.get_instance(this.instance);
      if(_.isEmpty(instance)) return "";
      if(instance.meta.channel == this.id) {
        return "";
      }
      var old_instance = _.find(this.instances, (instance) => { return instance.meta.channel == this.id; });
      if(!_.isEmpty(old_instance)) {
        return "This channel will be removed from the \""+old_instance.title+"\" instance";
      }
      return "";
    }
  },
  methods: {
    save (close) {
			var self = this;
      if (!this.id) return;

      var ws_channel = this.$cloudserver.channel("instances:"+this.instance);
      ws_channel.join();

      if (typeof(ws_channel) != "undefined") {

        var instance = _.cloneDeep(InstanceModel.get_instance(this.instance));
        if(!_.isEmpty(instance) && instance.meta.channel != this.id) {
          var old_instance = _.find(this.instances, (instance) => { return instance.meta.channel == this.id; });
          if(!_.isEmpty(old_instance) && !confirm("This channel will be removed from the \""+old_instance.title+"\" instance\nAre you sure?")) {
            return;
          }
        }

        instance.meta.channel = this.id;

				ws_channel.save({instance: instance})
					.then((msg) => {
						if (typeof(self.id) == "undefined") {
							self.$message.success("Instance was created!");
						} else {
							self.$message.success("Instance was updated!");
						}
            ws_channel.leave();
						if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.id}})
            }
					})
					.catch((msg) => {
						console.log(msg);
						if (typeof(self.id) == "undefined") {
							self.$message.warning("Unable to create instance!");
						} else {
							self.$message.warning("Unable to update instance!");
						}
            ws_channel.leave();
					});

      }
		},
    reset () {
      this.channel = this.convertChannel(this.ws_channel.data);
    },
    convertChannel (newVal, oldVal) {
      var channel = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }
      this.instance = ChannelModel.instance(channel);
      if(typeof(channel) == "undefined" || _.isEmpty(channel)) return undefined;
      return channel;
    }
  }
}
</script>
